import { createAction } from '@reduxjs/toolkit';

export const linksUpdateRequest = createAction('emailsLinks/updateRequest');
export const linksUpdateError = createAction('emailsLinks/updateError');
export const linksUpdateStore = createAction('emailsLinks/updateStore');

export const linksStore = createAction('emailsLinks/store');
export const linksClear = createAction('emailsLinks/clear');

export const linksUpdateId = createAction('emailsLinks/updateId');
export const linksUpdateHeadingTitle = createAction('emailsLinks/updateHeadingTitle');
export const linksUpdateHeadingDescription = createAction('emailsLinks/updateHeadingDescription');
export const linksUpdateLayout = createAction('emailsLinks/updateLayout');
export const linksUpdateItems = createAction('emailsLinks/updateItems');

export const linksAddItemRequest = createAction('emailsLinks/addItemRequest');
export const linksUpdateItemRequest = createAction('emailsLinks/updateItemRequest');
export const linksDeleteItemRequest = createAction('emailsLinks/deleteItemRequest');
